import { getAddress } from "viem";

export const nativeTokenAddress = getAddress(
  "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
);
